import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import Swal from 'sweetalert2';
import { SortleavesPipe } from '../pipe/sortleaves.pipe';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule, DatePipe } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
declare let $: any; 

@Component({
  selector: 'app-show-leaves',
  templateUrl: './show-leaves.component.html',
  styleUrls: ['./show-leaves.component.css', ],
  providers: [SortleavesPipe, DatePipe],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, MatPaginatorModule],
})

export class ShowLeavesComponent implements OnInit {
  example: any;

  nameFilter = '';
  startDateFilter: any;
  endDateFilter: any;
  arr: any = [];
  rejected_leave_id = 0;
  rejected_leave_index = 0;
  rejected_reason: any;
  public user: any = [];
  public showSpinner = true;
  pendingLeaves: any[] = [];
  approvedLeaves: any[] = [];
  rejectedLeaves: any[] = [];
  loannotification: any = {};
  count: any;
  notify: any = {};
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  refresh: any;
  update_leave_id: any;
  update_leave_index: any;
  redo_leave_index: any;
  redo_leave_id: any;
  pagedData?: any[] = []; // Comment: Added pagedData array to hold data for the current page
  pageSize = 25; // Comment: Set the default page size
  currentPage = 0; // Comment: Set the default current page
  @ViewChild(MatPaginator) paginator!: MatPaginator; // Comment: ViewChild to access the paginator
  @ViewChild('startPicker') startPicker?: ElementRef<HTMLInputElement>;
  @ViewChild('endPicker') endPicker?: ElementRef<HTMLInputElement>;
  sub_department: any;
  leaves_detail: any;
  match_department: any;
  isMatch: any;
  admindetail: any;
  adminstatus: any;
  subdep: any;
  dep: any;
  userRole: any;
  current_userrole: any;
  current_user: any;
  currentUser_dep: any;
  current_userid: any;
  button_check = false;
  rejectLeave = false;
  approvedleave = false;
  leavetype  = '';
  leaveStatus  ='';
  // currentLeaveDetail: any;

  currentLeaveDetail: any = {
    status: '',
    action_date: '',
    reason: '',
    admin: {
      first_name: '',
      last_name: '',
      profile_image: ''
    }
  };
  current_user_id: any;
  approveOrRecommendation: any;
  custome_message: any;
  start_date_form: any;
  end_date_form: any;
  leavenames: any =  '';
  leave_category: any;
  leaveCategory = '';
  leavePayment= '';
   isFilterExpanded = false; // For expandable/collapsible filter section
  constructor(
    private leaveService: LeaveService,
    public router: Router,
    private addService: AddService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private settings: SettingservicesService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }
  ngOnInit(): void {
    this.getLeaveMangement();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.user_refresh();
    this.leavestype();
    this.getTextForAutomation();
  }

  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

      const user_role = JSON.parse(this.user.user_role.user_roles)
      if (user_role.role_type == "Employee") {
        this.router.navigate(['/dashboard-1']);
      }
    })

  }
  leaveRejectionData: any;
  gettextauto: any;
  getTextForAutomation() {
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.leaveRejectionData = this.gettextauto.filter(
        (item: any) => item.title.trim() === "LEAVE_REJECTION_TEXT"
      );
      // this.leaveRejectionData = this.gettextauto.filter((item: any) => item.title === "LEAVE_REJECTION_TEXT");

    })
  }

  rejectedReason = '';
  setReason(text: string) {
    this.rejectedReason = text;
  }



  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.current_user_id = this.userInfo?.id
      this.sub_department = this.userInfo?.sub_department;
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
    })
  }
  getLeaveMangement() {
    this.showSpinner = true;
    const name = this.nameFilter;
    if (this.startDateFilter === null || this.startDateFilter === undefined) {
      this.startDateFilter = this.endDateFilter;
    }
    if (this.endDateFilter === null || this.endDateFilter === undefined) {
      this.endDateFilter = this.startDateFilter;
    }
    // Convert dates to API format (yyyy-MM-dd)
    const sdate = this.formatNative(this.startDateFilter) || this.startDateFilter;
    const edate = this.formatNative(this.endDateFilter) || this.endDateFilter;
    const leavetype = this.leavetype;
    const leaveStatus = this.leaveStatus;
    const leaveCategory = this.leaveCategory;
    const leavePayment = this.leavePayment


    this.leaveService.getLeaveMangement(name, sdate, edate,leavetype,leaveStatus,leaveCategory,leavePayment).then((value) => {
      this.arr = [];

      // value.data = this.transform(value.data);
      this.leaves_detail = value?.data

      value.data.forEach((x: any, index: number) => {
        const obj = x;
        obj.index = index;
        this.arr.push(obj);
      });

      this.updatePagedData(); // Comment: Call to update pagedData after fetching the data
      this.showSpinner = false;

    });
  }

  // transform(arr: any[]): any[] {

  //   if (!Array.isArray(arr)) {
  //     return arr;
  //   }
  //   const statusOrder = ['pending', 'approved', 'rejected'];
  //   return arr.sort((a, b) => statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status));
  // }

  onPageChange(event: PageEvent) { // Comment: Method to handle page changes
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePagedData();
  }

  updatePagedData() { // Comment: Method to update pagedData based on current page and page size
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.pagedData = this.arr.slice(startIndex, endIndex);

    console.log(this.pagedData)
  }

  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);
    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }
  isApproved = false;

  approve(index: number) {
    this.showSpinner = true;

    let status = 'approved';
    const id = this.arr[index].id;
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      status = 'approved';
    }
    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (this.arr[index].approval_or_recommendation == 0) {
        status = 'recommended';
      } else if (this.arr[index].approval_or_recommendation == 1) {
        status = 'approved';
      }
    }

    this.leaveService.getLeaveApproved(id, status).then((value) => {
      this.showSpinner = false;
      
      if (value.success == true) {
        // Update local data without reloading
        this.isApproved = true;
        this.arr[index].status = status;
        this.arr[index].admin_name = this.user.first_name + ' ' + this.user.last_name;
        this.arr[index].admin_image = this.user.profile_image;
        
        // Add new detail to leave_details if version 1
        if (this.arr[index].leave_version === '1') {
          if (!this.arr[index].leave_details) {
            this.arr[index].leave_details = [];
          }
          this.arr[index].leave_details.push({
            admin: {
              id: this.user.id,
              first_name: this.user.first_name,
              last_name: this.user.last_name,
              profile_image: this.user.profile_image
            },
            status: status,
            action_date: new Date().toISOString()
          });
          // Force array reference update for change detection
          this.arr[index].leave_details = [...this.arr[index].leave_details];
        }
        
        // Force arr reference update for change detection
        this.arr = [...this.arr];
        // Update the pagedData to reflect changes
        this.updatePagedData();
        // Trigger change detection to update the UI
        this.cdr.detectChanges();
        
        // Swal.fire({
        //   iconHtml:
        //     ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
        //   title: status === 'approved' ? 'Leave Approved Successfully' : 'Leave Recommended Successfully',
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.showSpinner = false;
    });
  }
  isRedoShow(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Admin") {
      return true
    }
    else {
      return false
    }
  }

  isUpdateLeavePermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.update
    }
  }
  isLeaveApprovedPermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.accept
    }
  }
  isLeaveRejectPermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type === "Employee") {
      return false
    } else if (user_role.role_type === "Team_Lead") {
      return false
    } else {
      return user_role.leave_data.data.values.reject
    }
  }
  onClickRejectLeave(index: number) {
    this.rejected_leave_id = this.arr[index].id;
    this.rejected_leave_index = index;
    this.getTextForAutomation();
  }

  reject(reason: NgForm) {
    const id = this.rejected_leave_id;
    const rejected_reason = reason.value.rejected_reason;
    this.showSpinner = true;
    this.leaveService.rejectLeave(id, rejected_reason).then((value) => {
      this.showSpinner = false;
      
      if (value.success == true) {
        // Update local data without reloading
        this.arr[this.rejected_leave_index].status = 'rejected';
        this.arr[this.rejected_leave_index].rejected_reason = rejected_reason;
        this.arr[this.rejected_leave_index].admin_name = this.user.first_name + ' ' + this.user.last_name;
        this.arr[this.rejected_leave_index].admin_image = this.user.profile_image;
        
        // Add new detail to leave_details if version 1
        if (this.arr[this.rejected_leave_index].leave_version === '1') {
          if (!this.arr[this.rejected_leave_index].leave_details) {
            this.arr[this.rejected_leave_index].leave_details = [];
          }
          this.arr[this.rejected_leave_index].leave_details.push({
            admin: {
              id: this.user.id,
              first_name: this.user.first_name,
              last_name: this.user.last_name,
              profile_image: this.user.profile_image
            },
            status: 'rejected',
            action_date: new Date().toISOString(),
            reason: rejected_reason
          });
          // Force array reference update for change detection
          this.arr[this.rejected_leave_index].leave_details = [...this.arr[this.rejected_leave_index].leave_details];
        }
        
        // Force arr reference update for change detection
        this.arr = [...this.arr];
        // Update the pagedData to reflect changes
        this.updatePagedData();
        // Trigger change detection to update the UI
        this.cdr.detectChanges();
        
        // Clear the form
        reason.resetForm();
        this.rejectedReason = '';
               // **Hide modal here**
        $('#rejectModal').modal('hide');
        
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Leave Rejected Successfully',
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      } else {
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      }
    }).catch(() => {
      this.showSpinner = false;
    });
  }
  onClickupatedLeave(index: number) {
    this.update_leave_id = this.arr[index].id;
    this.update_leave_index = index;
  }


  update(updateLeave: NgForm) {
    this.showSpinner = true;
    const id = this.update_leave_id
    const formatdate = updateLeave.value.start_date;
    const formatdate1 = updateLeave.value.end_date;

    const updatestartdate = this.datePipe.transform(formatdate, 'yyyy-MM-dd');
    const updateenddate = this.datePipe.transform(formatdate1, 'yyyy-MM-dd');
    this.leaveService.updatedate(id, updatestartdate, updateenddate).then((value) => {
      this.showSpinner = false;
      
      if (value.success == true) {
        // Update local data without reloading
        this.arr[this.update_leave_index].start_date = updatestartdate;
        this.arr[this.update_leave_index].end_date = updateenddate;
        
        // Update the pagedData to reflect changes
        this.updatePagedData();
        // Trigger change detection to update the UI
        this.cdr.detectChanges();
        
        // Clear form values
        this.start_date_form = null;
        this.end_date_form = null;
        updateLeave.resetForm();
         $('#updateModal').modal('hide');
        
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Leave updated Successfully',
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              // Prevent scroll restoration
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      } else {
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              // Prevent scroll restoration
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      }
    }).catch(() => {
      this.showSpinner = false;
    });
  }
  onClickredo(index: number) {
    this.redo_leave_id = this.arr[index].id;
    this.redo_leave_index = index;
  }

  redo() {
    const current_userId = this.user?.id
    this.showSpinner = true;
    const id = this.redo_leave_id
    this.leaveService.redoLeave(id, current_userId).then((value) => {
      this.showSpinner = false;
      
      if (value.success == true) {
        // Update local data without reloading
        // Remove the last action from leave_details
        if (this.arr[this.redo_leave_index].leave_details && 
            this.arr[this.redo_leave_index].leave_details.length > 0) {
          this.arr[this.redo_leave_index].leave_details.pop();
          
          // Update status based on remaining leave_details
          if (this.arr[this.redo_leave_index].leave_details.length === 0) {
            this.arr[this.redo_leave_index].status = 'pending';
          } else {
            const lastDetail = this.arr[this.redo_leave_index].leave_details[
              this.arr[this.redo_leave_index].leave_details.length - 1
            ];
            this.arr[this.redo_leave_index].status = lastDetail.status;
          }
          // Force array reference update for change detection
          this.arr[this.redo_leave_index].leave_details = [...this.arr[this.redo_leave_index].leave_details];
        }
        
        // Force arr reference update for change detection
        this.arr = [...this.arr];
        // Update the pagedData to reflect changes
        this.updatePagedData();
        // Trigger change detection to update the UI
        this.cdr.detectChanges();
        
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Action Redo Successfully',
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              // Prevent scroll restoration
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      } else {
        setTimeout(() => {
          Swal.fire({
            iconHtml:
              ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
            didClose: () => {
              // Prevent scroll restoration
              window.scrollTo(0, document.documentElement.scrollTop);
            }
          });
        }, 100);
      }
    }).catch(() => {
      this.showSpinner = false;
    });
  }




  storeValue(val: any, approveOrRecommendation: any) {
    this.example = val;
    this.approveOrRecommendation = approveOrRecommendation;
  }
  getApprovalButtonModalLabel(_approval_or_recommendation: any): string {
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      return 'Approve';
    }

    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (_approval_or_recommendation == 0) {
        return 'Recommend';
      } else if (_approval_or_recommendation == 1) {
        return 'Approve';
      }
    }

    return 'Approve'; // default fallback
  }

  // Shownotificaton(count : any){
  //   var user_role = JSON.parse(this.user.user_role.user_roles)
  //   if(user_role.role_type != "Team_Lead"){
  //   this.count = "leave_request";
  //   this.addService.showNotify(this.count).then((value) =>{

  //     this.notify = value.data
  //   })
  // }
  // }


  isAdmindata(leave: any): boolean {
    let isAdminData = false
    if (leave.leave_details.length > 0) {
      return isAdminData = true
    } else {
      return isAdminData = false
    }
  }

  // Call this method in your component where needed
  isShowApprovalButtons(leave: any): boolean {
    this.current_user = JSON.parse(this.user.user_role.user_roles)
    this.current_userrole = this.current_user?.role_type
    // leave.approval_or_recommendation==0
    if (leave.leave_details.length > 0) {
      // user who sign up role
      let isButtonVissible = true;

      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role
        // Check both detail.admin_id (old format) and detail?.admin?.id (new format)
        if ((detail.admin_id == this.current_userid || detail?.admin?.id == this.current_userid) || (this.userRole == this.current_userrole && this.currentUser_dep == this.dep)) {
          isButtonVissible = false; // Hide button
        }

      });
      return isButtonVissible

    } else {

      return true
    }

  }
  getApprovalButtonLabel(leave: any): string {
    const user = JSON.parse(this.user.user_role.user_roles)
    const current_userrole1 = user?.role_type
    // If role is admin → Always Approve
    if (current_userrole1 === 'Admin') {
      return 'Approve';
    }

    // If role is teamlead
    if (current_userrole1 === 'Team_Lead' || current_userrole1 === 'Admin_AND_Team_Lead') {
      if (leave.approval_or_recommendation == 0) {
        return 'Recommend';
      } else if (leave.approval_or_recommendation == 1) {
        return 'Approve';
      }
    }

    return 'Approve'; // default fallback
  }
  // isShowrejectstatus(leave: any): boolean {
  //   if (leave.leave_details.length > 0) {
  //     var isLeaveStatus = true;
  //     this.current_user = JSON.parse(this.user.user_role.user_roles)
  //     this.current_userrole = this.current_user?.role_type
  //     this.currentUser_dep = this.user?.department
  //     this.current_userid = this.user?.id
  //     leave.leave_details.forEach((detail: any) => {
  //       this.admindetail = detail?.admin
  //       this.adminstatus = detail?.status
  //       this.dep = detail?.user_dep
  //       this.userRole = detail?.user_role
  //       if (this.adminstatus == 'rejected') {
  //         isLeaveStatus = false; // Hide button
  //       }
  //     });
  //     return isLeaveStatus

  //   } else {
  //     return true
  //   }

  // }
  isShowrejectstatus(leave: any): string {
    if (leave.leave_details.length > 0) {
      this.current_user = JSON.parse(this.user.user_role.user_roles);
      this.current_userrole = this.current_user?.role_type;
      this.currentUser_dep = this.user?.department;
      this.current_userid = this.user?.id;

      let status = 'approved'; // default

      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin;
        this.adminstatus = detail?.status;
        this.dep = detail?.user_dep;
        this.userRole = detail?.user_role;

        if (this.adminstatus === 'rejected') {
          status = 'rejected';
        } else if (this.adminstatus === 'recommended' && (this.userRole === 'Team_Lead' || this.userRole === 'Admin_AND_Team_Lead')) {
          status = 'recommended';
        }
      });

      return status;
    } else {
      return 'approved'; // default when no details
    }
  }

  isShowredobutton(leave: any): boolean {
    if (leave.leave_details.length > 0) {
      let isredoStatus = false;
      this.current_user = JSON.parse(this.user.user_role.user_roles)
      this.current_userrole = this.current_user?.role_type
      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role

        if (this.admindetail?.id == this.current_userid && this.adminstatus != 'pending' && this.current_userrole == 'Admin') {
          isredoStatus = true; // show button
        }
      });
      return isredoStatus

    } else {
      return false
    }
  }



  isPendingstatus(leave: any): boolean {
    let ispendiingStatus = true
    if (leave.leave_details.length = 0) {
      ispendiingStatus = false
      return ispendiingStatus
    } else {
      return true
    }

  }

  showLeaveDetail(details: any) {
    this.currentLeaveDetail = details;
  }





  // isavailablefeature(type: string): boolean {
  //   switch (type) {
  //     case "isView":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.leave_data.data.values.view_leave === false
  //     case "isAccept":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.leave_data.data.values.accept === false
  //     case "isReject":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.leave_data.data.values.reject === false
  //     case "isUpdate":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return !user_role.leave_data.data.values.update === false
  //     case "isViewLeaveReport":
  //       var user_role = JSON.parse(this.user.user_role.user_roles);
  //       return user_role?.leave_data?.data?.values?.view_leave_report === true
  //     default:
  //       return false;
  //   }
  //   return false
  // }

  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.leave_data?.data?.values;

    switch (type) {
      case "isView":
        return values?.view_leave ?? false;

      case "isAccept":
        return values?.accept ?? false;

      case "isReject":
        return values?.reject ?? false;

      case "isUpdate":
        return values?.update ?? false;

      case "isViewLeaveReport":
        return values?.view_leave_report ?? false;

      case "isUndo":
        return values?.undo_leave ?? false;

      default:
        return false;
    }
  }


  changeEndDate(formValue: any) {

    this.showSpinner = true;
    const leave_type_id = 2
    const short_start_date = 'Null';
    const start_time = 'Null';
    const end_time = 'Null';
    const start_date = formValue.start_date ?? 'Null';
    const formatted_start_date = this.convertDate(start_date) ?? 'Null';
    const end_date = formValue.end_date ?? 'Null';
    this.leaveService.getcheckapplyLeave(leave_type_id, short_start_date, start_time, end_time, formatted_start_date, end_date).then((value: any) => {
      if (value.success == true) {
        // means found data agaisnt this data warning check show true

        if (value.message.type == "Atendance") {
          this.custome_message = "Your Attendance Record is Found in this day.Do you Still Want To Proceed."
        } else (
          this.custome_message = "Your Leave Record is Found in this day.Do you Still Want To Proceed."
        )

        Swal.fire({
          iconHtml: '<img src="../../../../assets/theme1/warning.png" alt="image">',
          title: this.custome_message,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          showDenyButton: true,
          denyButtonText: "No",
          allowOutsideClick: false, // prevent closing on outside click
          allowEscapeKey: false     // prevent closing on ESC
        }).then((result) => {
          if (result.isConfirmed) {
            // ✅ user clicked Yes → keep selected start_date and set end_date to it
            this.start_date_form = formValue.start_date;
            this.end_date_form = formValue.end_date;
          } else if (result.isDenied) {
            this.start_date_form = null;
            this.end_date_form = null;
          }
        });

      }
      this.showSpinner = false;

    });

  }


  formatDate(date: string | null): string | null {
    if (!date) return null;

    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) return null; // invalid date → return null

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = dateObj.toLocaleString('default', { month: 'short' }); // e.g., 'Sep'
    const year = dateObj.getFullYear();

    return `${month} ${day}, ${year}`;
  }
  convertDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  toApiFormat(date: string | null): string | null {
    if (!date) return null;

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return null;

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // Date formatting methods for the new date picker
  // Always show like "20 Jan 2026"
  formatDisplay(d: Date | string | null): string {
    if (!d) return '';
    const date = typeof d === 'string' ? new Date(d) : d;
    return this.datePipe.transform(date, 'd MMM yyyy') ?? '';
  }

  // Native input expects "yyyy-MM-dd"
  formatNative(d: Date | string | null): string {
    if (!d) return '';
    const date = typeof d === 'string' ? new Date(d) : d;
    return this.datePipe.transform(date, 'yyyy-MM-dd') ?? '';
  }

  openStartPicker() {
    const el = this.startPicker?.nativeElement;
    if (el?.showPicker) el.showPicker(); else el?.focus();
  }

  openEndPicker() {
    const el = this.endPicker?.nativeElement;
    if (el?.showPicker) el.showPicker(); else el?.focus();
  }

  applyStart(e: Event) {
    const val = (e.target as HTMLInputElement).value; // "yyyy-MM-dd"
    if (val) {
      this.startDateFilter = val;
    } else {
      this.startDateFilter = null;
    }
  }

  applyEnd(e: Event) {
    const val = (e.target as HTMLInputElement).value;
    if (val) {
      this.endDateFilter = val;
    } else {
      this.endDateFilter = null;
    }
  }


  resetfilter() {
    this.showSpinner = true;


    const name = this.nameFilter = '';
    if (this.startDateFilter === null || this.startDateFilter === undefined) {
      this.startDateFilter = this.endDateFilter;
    }
    if (this.endDateFilter === null || this.endDateFilter === undefined) {
      this.endDateFilter = this.startDateFilter;
    }
    // Convert dates to API format (yyyy-MM-dd)
    let sdate = this.formatNative(this.startDateFilter) || this.startDateFilter;
    let edate = this.formatNative(this.endDateFilter) || this.endDateFilter;
    sdate= this.startDateFilter ='';
    edate= this.endDateFilter = '';
    const leavetype = this.leavetype = '';
    const leaveStatus = this.leaveStatus = '';
    const leaveCategory = this.leaveCategory = '';
    const leavePayment = this.leavePayment = '';


    this.leaveService.getLeaveMangement(name, sdate, edate,leavetype,leaveStatus,leaveCategory , leavePayment).then((value) => {
      this.arr = [];

      // value.data = this.transform(value.data);
      this.leaves_detail = value?.data

      value.data.forEach((x: any, index: number) => {
        const obj = x;
        obj.index = index;
        this.arr.push(obj);
      });

      this.updatePagedData(); // Comment: Call to update pagedData after fetching the data

      this.showSpinner = false;
    });
    
    
  }

  leavestype() {
    this.showSpinner = true;
    this.dashboardService.getleaves().then((value) => {
      
      this.leavenames = value.data
      this.leave_category = this.leavenames.length;
     
      this.showSpinner = false;
    })
  }



    // Toggle filter section expand/collapse
  toggleFilterSection() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }



  getOrdinalSuffix(num: number): string {
  if (num >= 11 && num <= 13) return 'th';

  switch (num % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

}
